import React, { useEffect, useState } from "react";
import {
    Dialog,
    DialogContent,
    DialogActions,
    Grid,
    Button,
    TextField,
    colors,
    DialogTitle,
    Paper,
    Divider,
    Hidden,
    TableContainer,
    LinearProgress,
} from "@material-ui/core";
import { uri } from "../../../../../help/Api";
import { sto } from "../../../../../Context/InshData";
import axios from "axios";
// import { SharedGroupIdProvider } from "../../../InvoiceRest/RestProductsG";
import CheckRestrictionsTable from "./CheckRestrictionsTable";
import GroupLists from "../../../../Invs/BackEnd/InvoiceRest/GroupLists";
import { GroupSelectRest } from "../../../../Invs/BackEnd/POS/GroupSelectRest";
import { SharedGroupIdProvider } from "../../../../Invs/BackEnd/InvoiceRest/RestProductsG";
import { useStylesItemDilog } from "../../../../Invs/BackEnd/models/ItemDataDialog";
import { useStylesDPM } from "../../../../../St/comps/UseStyle";
import { GetIndexFromIdOptions } from "../../receipt-voucher/external-exchange-voucher/EExchangeVoucher";
const typeSetting = [
    { id: 1, name: "قيود غير متزنه", color: -1 },
    { id: 2, name: "قيود غير متزنه اقل من التاريخ الحالي", color: -1 },
    { id: 3, name: "قيود غير متزنه حسابات غير موجودة في الدليل المحاسبي", color: -1 },
    { id: 4, name: "قيود غير متزنه حسابات رئيسية ولها عمليات", color: -1 },
];
export default function CheckRestrictions(props) {
    const { openCheck, setOpenCheck, rptParams, database,AutoOptions } = props;
    const classes = useStylesItemDilog();

    const [selectColor, setSelectColor] = useState({ id: 0, color: colors.blue[300] });
    const [data, setData] = useState([]);
    const [fetching, setFetching] = useState(false);
    const getCloseDialog = () => {
        setOpenCheck(false);
    }
    const viewHandle = async (row) => {
        setData([]);
        setFetching(true);
        await axios
            .get(
                uri + `AccountReports/rptCheckRestProblem?dateFrom=${rptParams.dateFrom}&&dateTo=${rptParams.dateTo}
            &&CheckType=${row.id}&&db_name=${database?.name??""}`
            )
            .then((res) => {
                const resData = res.data.map((row, i) => {
                    return {
                        ...row,
                        BranchName:GetIndexFromIdOptions(row.branch,AutoOptions.Branches)?.name??""
                    };
                });

                setData(resData);
                setFetching(false);
            })
            .catch((err) => {
                setData([]);
                setFetching(false);
            });
    };

    const onRowClick = (row) => {
        setSelectColor({ ...row, color: colors.blue[300] });
        viewHandle(row);
    };
    const clasPM = useStylesDPM();

    return (
        <Dialog
            fullScreen
            className={clasPM.rootPM}
            open={openCheck}
            lg={{ direction: "rtl", minHeight: 400 ,maxHeight:400}}
            onClose={getCloseDialog}
            aria-labelledby="form-dialog-title"
            key={""}
        >
            <DialogTitle style={{ textAlign: "center" }} > {"check Restrictions "}</DialogTitle>
            <DialogContent className={clasPM.dialogContentPM}>
                <Grid item container style={{ direction: "ltr" }} spacing={1}>
                    <Grid item lg={9} md={8} sm={12} xs={12}>
                        {fetching ?
                            <TableContainer component={Paper}>
                                {"يرجى الانتظار قليلا حتى يتم جلب البيانات ..."}
                                <LinearProgress />
                            </TableContainer> :
                            <Paper style={{ minHeight: "30vh", maxHeight: "30vh", overflow: "auto", width: "100%" }} >
                                <SharedGroupIdProvider>
                                    <CheckRestrictionsTable {...{
                                        data: data ? data : [],
                                        database
                                    }} />
                                    <Divider />
                                </SharedGroupIdProvider>
                            </Paper>
                        }
                    </Grid>
                    <Grid item lg={3} md={4} sm={12} xs={12}>
                        <Hidden smDown>
                            <Paper
                                style={{ minHeight: "100%", maxHeight: "100%", overflow: "auto", }}
                            >
                                <SharedGroupIdProvider>
                                    <GroupLists
                                        groups={[...typeSetting]}
                                        onRowClick={onRowClick}
                                        isMain={true}
                                        GroupColor={selectColor}
                                    />
                                    <Divider />
                                </SharedGroupIdProvider>
                            </Paper>
                        </Hidden>
                        <Hidden mdUp>
                            <GroupSelectRest
                                groups={[...typeSetting]}
                                onRowClick={onRowClick}
                                isMain={true}
                                GroupColor={selectColor}
                            />
                        </Hidden>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions className={classes.dialogAction}>
                <Button onClick={() => getCloseDialog()}>إغلاق </Button>
            </DialogActions>
        </Dialog>
    );
}

